/**
 * Table functions
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericComponentInstance } from "@adapptio/lib-blueprint";

import { IAllowedResizeDimensions } from "@adapptio/lib-components";

/**
 * Resolves allow resize
 */
export function resolveAllowResize(
	componentInstance: TGenericComponentInstance<null>
): IAllowedResizeDimensions {
	if (!componentInstance.modelNode) {
		return null;
	}

	return {
		left: false,
		top: false,
		width: false,
		height: false
	};
}
